module.exports = __webpack_public_path__ + "media/components/t-shirt-comp/static/Hendaye-Plage-d60a29618bcaa7e217f7fd321efd2495.jpg";